import { render, staticRenderFns } from "./FAreaDialog.vue?vue&type=template&id=04253894&scoped=true"
import script from "./FAreaDialog.vue?vue&type=script&lang=js"
export * from "./FAreaDialog.vue?vue&type=script&lang=js"
import style0 from "./FAreaDialog.vue?vue&type=style&index=0&id=04253894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04253894",
  null
  
)

export default component.exports